/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import {
  createClient,
  TagData,
  TelemetryOptions,
} from '@getgo/telemetry-client';
import { createTransport } from '@getgo/telemetry-client/lib/fetch-buffered-queue';
import uuid from 'uuid4';
import { machine } from '../lib/machine';
import platform from 'platform';

const eventSource = 'LogMeIn.GoTo.ULF';
const eventSchemaName = 'ep_telemetry';
const eventSchemaVersion = '0';

export class TelemetryService {
  event: (name: string, attributes?: Object | undefined) => Promise<any>;
  flush: () => any;

  constructor(telemetryServiceBaseUrl: string) {
    const telemetryOptions: TelemetryOptions = {
      ev_source: eventSource,
      ev_schema_name: eventSchemaName,
      ev_schema_ver: eventSchemaVersion,
      id_dev: machine.id,
      id_run: uuid(),
    };

    const transport = createTransport(
      `${telemetryServiceBaseUrl}/reportEvent`,
      telemetryOptions
    );
    const telemetry = createClient(
      transport.add.bind(transport),
      telemetryOptions
    );
    telemetry.setGlobalAttributes(globalClientAttributes);
    this.event = telemetry.event;
    this.flush = transport.flush;
  }
}

const productName = 'Unified Launch Frontend';
const unknown = 'unknown';

// see https://confluence.ops.expertcity.com/display/Arch/Telemetry+Naming+Convention
export const globalClientAttributes: TagData = {
  ga_browserName: platform.name ?? unknown,
  ga_browserVersion: platform.version ?? unknown,
  hw_model_id: 'NA for Browser',
  hw_model_name: platform.product ?? unknown,
  hw_net: 'NA for Browser',
  os_arch: String(platform.os?.architecture ?? unknown),
  os_locale: navigator.language,
  os_type: platform.os?.family ?? unknown,
  os_ver: platform.os?.version ?? unknown,
  sw_build: process.env.REACT_APP_GIT_SHA ?? unknown,
  sw_plat: navigator.platform,
  sw_prod_name: productName,
  sw_prod_ver: process.env.REACT_APP_VERSION ?? unknown,
};
